<template>
    <div :id="popupId" :class="onModalClass" ref="cursor">
        <button class="close-btn" aria-label="상세보기 화면 닫기" @click="doCloseWinNotice"></button>
        <div class="popup-conts">
            <div v-if="noticeDtlInfo?.noticeFileUrl" class="pop-img">
                <img :src="noticeDtlInfo.noticeFileUrl" alt="공지사항 이미지" />
            </div>
            <div class="pop-detail">
                <div class="ev-top-info">
                    <h2 class="tit">{{ noticeDtlInfo.noticeTitle }}</h2>
                </div>
                <!--   내용(editor) -->
                <div class="ev-btm-detail" v-html="noticeDtlInfo.noticeConts" />
                <!-- //내용(editor) -->
            </div>
        </div>
    </div>
</template>

<script setup>
    defineOptions({
        name: 'NoticeDetail',
    });

    import { onBeforeMount, onUpdated, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import { useRootStore } from '@/stores/modules';
    import { setHeaderTitle } from '@/utils/commonUtil';

    const emit = defineEmits(['close']);

    const $route = useRoute();

    const noticeId = ref('');
    const onModalClass = ref('');
    const popupId = ref('');
    const noticeDtlInfo = ref({});
    const isModal = ref(false);
    const cursor = ref(null);

    const getNoticeDetail = async (noticeId, gbn) => {
        const url = `/notice/detail?noticeId=${noticeId}`;
        const res = await useRootStore().getStarFieldInfo(url);

        if (res.status === 200) {
            noticeDtlInfo.value = res.data.noticeDetail;

            // 모달이 아닌경우
            if (gbn !== 'MODAL') {
                isModal.value = false;

                // 팝업 CSS 설정
                onModalClass.value = 'popup-wrap';

                // 팝업ID변경 CSS제어
                popupId.value = 'popup-page';

                // 페이지이동인 경우 브라우저 뒤로가기버튼 제어
                localStorage.setItem('gotoPage', 'Y');

                // 타이틀 표시
                if (gbn === 'PAGE') {
                    let strTitle = noticeDtlInfo.value.noticeTitle;
                    const maxLength = 12;
                    if (strTitle.length > maxLength) {
                        strTitle = strTitle.substring(0, maxLength) + '...';
                    }

                    setHeaderTitle(strTitle);
                }

                // 모달인 경우
            } else {
                isModal.value = true;

                // 팝업 CSS 설정
                onModalClass.value = 'popup-wrap slideUp';

                cursor.value?.scrollTo({ top: 0 });
            }
        }
    };
    // [X]버튼 클릭시
    const doCloseWinNotice = () => {
        // 모달 초기화
        isModal.value = false;
        // 바깥부분 Scroll처리
        document.body.classList.remove('no-scroll');
        onModalClass.value = 'popup-wrap slideDown';
        // 공지사항모달 감추기
        setTimeout(() => {
            onModalClass.value = '';
            emit('close');
        }, 300);
    };

    onUpdated(() => {
        if (isModal.value) {
            //focus 작업 시작======================
            const modal = cursor.value;
            const modalcontents = document.querySelector('.popup-conts');
            modalcontents.setAttribute('tabindex', 1);

            const focusableEls = modal.querySelectorAll(
                'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, img, object, div, embed',
            );
            focusableEls.forEach(function (item, index) {
                item.setAttribute('tabindex', index + 2);
            });

            const firstFocusableEl = focusableEls[0];
            firstFocusableEl.focus();

            const lastFocusableEl = focusableEls[focusableEls.length - 1];

            const modalTrapFocus = (event) => {
                if (event.key === 'Tab') {
                    if (document.activeElement === lastFocusableEl && !event.shiftKey) {
                        firstFocusableEl.focus();
                        event.preventDefault();
                    } else if (document.activeElement === firstFocusableEl && event.shiftKey) {
                        lastFocusableEl.focus();
                        event.preventDefault();
                    }
                }
            };
            document.addEventListener('keydown', modalTrapFocus);
            //focus 작업 종료======================
        }
    });
    onBeforeMount(() => {
        // 공지상세(페이지이동)
        noticeId.value = $route.params.noticeId ? $route.params.noticeId : '';

        // 공지상세(팝업) - 새창
        let sendData = null;
        try {
            sendData = JSON.parse(localStorage.getItem('sendData'));
        } catch (err) {
            console.log(err);
        }

        // 공지상세(페이지 이동인 경우)
        if (noticeId.value) {
            getNoticeDetail(noticeId.value, 'PAGE');

            // 팝업의 경우
        } else if (sendData && sendData.noticeId) {
            getNoticeDetail(sendData.noticeId, 'NEWPOP');

            // 전달되는 인수의 초기화
            localStorage.setItem('sendData', null);
        }
    });

    defineExpose({ getNoticeDetail });
</script>
